import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import { useAuth } from '../lib/auth';
import './signing.css';

// Signing Package Hub (DocuSign + client signing portal). Admin pages live under /admin/signing/*
// and use the monolith admin session; client-facing links stay public at /sign/:token.
const Dashboard = lazy(() => import('./pages/Dashboard'));
const ClientsPage = lazy(() => import('./pages/ClientsPage'));
const ClientDetailPage = lazy(() => import('./pages/ClientDetailPage'));
const PackagesPage = lazy(() => import('./pages/PackagesPage'));
const PackagePreviewPage = lazy(() => import('./pages/PackagePreviewPage'));
const ClientPortalPreviewPage = lazy(() => import('./pages/ClientPortalPreviewPage'));
const SignaturePlacerPage = lazy(() => import('./pages/SignaturePlacerPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
// V3 is the client experience Matt built (scroll story, in-browser PDF, draw/type signature, welcome videos). The older
// ClientSigningPortal / ClientSigningPortalScrolling files are kept only for reference.
const ClientSigningPortal = lazy(() => import('./pages/ClientSigningPortalV3'));
const SigningCompletePage = lazy(() => import('./pages/SigningCompletePage'));

const Fallback = () => <div className="p-10 text-sm text-slate-500" data-testid="signing-loading">Loading signing hub…</div>;

// The ported pages expect a Google-auth `user` prop for the header avatar — feed them the admin session user.
function WithAdminUser({ Page }) {
  const { user } = useAuth();
  const u = user ? { name: user.name || user.email, email: user.email, picture: user.picture } : null;
  return <div className="signing-hub"><Page user={u} setUser={() => {}} /></div>;
}

const adm = (Page) => (
  <ProtectedRoute>
    <Suspense fallback={<Fallback />}><WithAdminUser Page={Page} /></Suspense>
  </ProtectedRoute>
);
const pub = (el) => <Suspense fallback={<Fallback />}><div className="signing-hub">{el}</div></Suspense>;

export const signingRoutes = [
  <Route key="sg1" path="/admin/signing" element={adm(Dashboard)} />,
  <Route key="sg2" path="/admin/signing/dashboard" element={adm(Dashboard)} />,
  <Route key="sg3" path="/admin/signing/clients" element={adm(ClientsPage)} />,
  <Route key="sg4" path="/admin/signing/clients/:clientId" element={adm(ClientDetailPage)} />,
  <Route key="sg5" path="/admin/signing/packages" element={adm(PackagesPage)} />,
  <Route key="sg6" path="/admin/signing/packages/:packageId/preview" element={adm(PackagePreviewPage)} />,
  <Route key="sg7" path="/admin/signing/packages/:packageId/client-preview" element={adm(ClientPortalPreviewPage)} />,
  <Route key="sg8" path="/admin/signing/documents/:docId/place-fields" element={adm(SignaturePlacerPage)} />,
  <Route key="sg9" path="/admin/signing/settings" element={adm(SettingsPage)} />,
  <Route key="sg10" path="/sign/:token" element={pub(<ClientSigningPortal />)} />,
  <Route key="sg11" path="/signing-complete" element={pub(<SigningCompletePage />)} />,
];
